import { SvgCheveronDown, SvgCollapse, SvgExpand } from '@/components/icons';
import { usePref } from '@/store/prefs';

type BudgetNameProps = {
  floating: boolean;
  onToggleFloating: () => void;
};

/**
 * Budget title at the top of the sidebar. The chevron is kept for visual
 * parity, but the budget-file manager screens it opens upstream are out of
 * this clone's scope, so it is not a control here.
 */
export function BudgetName({ floating, onToggleFloating }: BudgetNameProps) {
  const [budgetName] = usePref('budgetName');

  return (
    <div className="flex shrink-0 items-center gap-1 px-4 pt-5 pb-2">
      <span className="flex min-w-0 items-center gap-1 text-[17px] font-medium text-sidebar-header-text">
        <span className="truncate" data-testid="sidebar-budget-name">
          {budgetName ?? '预算'}
        </span>
        <SvgCheveronDown
          width={14}
          height={14}
          className="shrink-0 text-sidebar-text-muted"
        />
      </span>
      <div className="flex-1" />
      <button
        type="button"
        onClick={onToggleFloating}
        title={floating ? '取消悬浮侧边栏' : '悬浮侧边栏'}
        data-testid="sidebar-float-toggle"
        className="shrink-0 rounded-sm p-1 text-sidebar-text-muted hover:bg-sidebar-item-background-hover hover:text-sidebar-item-text"
      >
        {floating ? (
          <SvgCollapse width={15} height={15} />
        ) : (
          <SvgExpand width={15} height={15} />
        )}
      </button>
    </div>
  );
}
